import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';

import Galleries from 'api/resources/galleries';
import getErrors, { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import Loader from 'components/Loader';

import Main from 'styled/Page/Main';
import ErrorText from 'styled/Page/ErrorText';
import CenteredContainer from 'styled/Page/CenteredContainer';
import GalleryForm from 'admin-editor/containers/GalleryForm';

export class GalleryPage extends React.PureComponent {
  state = {
    loading: false,
    loadingSave: false,
    errors: [],
    gallery: null,
  }

  componentDidMount() {
    this.loadGallery();
  }

  get title() {
    return this.state.gallery
      ? this.state.gallery.title
      : this.props.match.params.galleryId;
  }

  handleSubmit = async ({ data, isExit } = {}) => {
    this.setState({ loadingSave: true });

    try {
      const response = await Galleries.patch({
        galleryId: this.props.match.params.galleryId,
        body: { data },
        include: 'gallery_files,gallery_files.image',
        fields: {
          gallery: 'title,gallery_files',
        },
      });

      const gallery = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        loadingSave: false,
        gallery,
      });
      Alert.success('Галерея успешно сохранена');

      if (isExit) {
        this.props.history.push('/galleries');
      }
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loadingSave: false });
    }
  }

  async loadGallery() {
    this.setState({
      loading: true,
      errors: [],
    });

    try {
      const response = await Galleries.get({
        galleryId: this.props.match.params.galleryId,
        include: 'gallery_files,gallery_files.image',
        fields: {
          gallery: 'title,gallery_files',
          galleryFile: 'title,image',
        },
      });

      const gallery = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        gallery,
        loading: false,
      });
    } catch (err) {
      getErrors(err).then((errors) => {
        this.setState({ errors });
      });
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Main>
        <Helmet>
          <title>{this.title}</title>
        </Helmet>

        {!this.state.loading &&
          this.state.gallery && (
          <GalleryForm
            title={this.state.gallery.title}
            galleryFiles={this.state.gallery.galleryFiles}
            errors={this.state.errors}
            onSubmit={this.handleSubmit}
            loadingSave={this.state.loadingSave}
          />
        )}

        {this.state.loading && (
          <CenteredContainer style={{ width: '100%' }}><Loader /></CenteredContainer>
        )}

        {!this.state.loading &&
          this.state.errors.length > 0 && (
          <CenteredContainer style={{ width: '100%' }}>
            {this.state.errors.map(error => (
              <ErrorText role="alert" key={error}>{error}</ErrorText>
            ))}
          </CenteredContainer>
        )}
      </Main>
    );
  }
}

GalleryPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      galleryId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

GalleryPage.defaultProps = {
  history: { push: () => {} },
};

export default withRouter(GalleryPage);
